import { createBoundContext } from '@bonusly/ds-utils';

import { AvatarSize, AvatarVariant } from '../types';

interface AvatarContextValue {
	bg: string;
	size: AvatarSize;
	textColor: string;
	variant: AvatarVariant;
}

export const [AvatarContextProvider, useAvatarContext] = createBoundContext<AvatarContextValue>({
	providerName: 'AvatarContextProvider',
	hookName: 'useAvatarContext',
});
